import { useMemo } from 'react';

import type { Person } from 'schema-dts';

import { useDecisionMakerProfilePageData } from 'src/app/pages/decisionMakerProfile/pageContext';
import { jsonLd } from 'src/app/shared/utils/jsonLd';

type Result = ModelHookResult<{
	schemaJson: string;
}>;

export function usePersonSchema(): Result {
	const {
		data: { description, displayName, id, photo, title: jobTitle, slug, state },
	} = useDecisionMakerProfilePageData();

	const slugOrId = slug || id;
	const image = useMemo(() => {
		return photo?.userLarge.url ? `https:${photo.userLarge.url}` : null;
	}, [photo]);

	const personSchema = useMemo(
		() =>
			jsonLd<Person>({
				'@context': 'https://schema.org',
				'@type': 'Person',
				name: displayName,
				url: `https://www.change.org/decision-makers/${slugOrId}`,
				description: description ? description.slice(0, 150) : undefined,
				...(image && { image }),
				...(jobTitle && { jobTitle }),
				...(state && {
					address: {
						'@type': 'PostalAddress',
						addressRegion: state,
						addressCountry: 'US',
					},
				}),
			}),
		[displayName, slugOrId, description, image, jobTitle, state],
	);

	return {
		data: {
			schemaJson: personSchema,
		},
	};
}
